/**
 * @generated SignedSource<<287c93cf4227afed74747133fdc6aa90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AgenticWorkerResultState = "NEEDS_REVIEW" | "DONE" | "DELETED" | "%future added value";
export type AgenticWorkerRowType = "PROJECT_BILLING_ROW" | "RETAINER_PERIOD_ROW" | "%future added value";
export type AgenticWorkerRunState = "RUNNING" | "STOPPED" | "NOTHING_FOUND" | "PRODUCED" | "FAILED" | "NOT_STARTED" | "%future added value";
export type AgenticWorkerScopeKind = "PAGE" | "ROW" | "%future added value";
export type agentRunStateSettleQuery$variables = {
  agentId: string;
  runId: string;
};
export type agentRunStateSettleQuery$data = {
  readonly viewer: {
    readonly agenticWorker: {
      readonly activeRuns: ReadonlyArray<{
        readonly id: string;
        readonly scopeKind: AgenticWorkerScopeKind;
        readonly scopeRowType: AgenticWorkerRowType | null;
        readonly scopeRowId: number | null;
        readonly state: AgenticWorkerRunState;
        readonly rows: ReadonlyArray<{
          readonly rowType: AgenticWorkerRowType;
          readonly rowId: number;
        }>;
      }>;
      readonly waitingResults: ReadonlyArray<{
        readonly id: string;
        readonly runId: string;
        readonly rows: ReadonlyArray<{
          readonly rowType: AgenticWorkerRowType;
          readonly rowId: number;
        }>;
        readonly state: AgenticWorkerResultState;
        readonly hidden: boolean;
      }>;
      readonly run: {
        readonly id: string;
        readonly scopeKind: AgenticWorkerScopeKind;
        readonly scopeRowType: AgenticWorkerRowType | null;
        readonly scopeRowId: number | null;
        readonly state: AgenticWorkerRunState;
        readonly rows: ReadonlyArray<{
          readonly rowType: AgenticWorkerRowType;
          readonly rowId: number;
        }>;
        readonly foundDetail: string | null;
      } | null;
    } | null;
  } | null;
};
export type agentRunStateSettleQuery = {
  variables: agentRunStateSettleQuery$variables;
  response: agentRunStateSettleQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "runId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scopeKind",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scopeRowType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scopeRowId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "AgenticWorkerResultRow",
  "kind": "LinkedField",
  "name": "rows",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "agentId",
      "variableName": "agentId"
    }
  ],
  "concreteType": "AgenticWorker",
  "kind": "LinkedField",
  "name": "agenticWorker",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AgenticWorkerRun",
      "kind": "LinkedField",
      "name": "activeRuns",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AgenticWorkerResult",
      "kind": "LinkedField",
      "name": "waitingResults",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "runId",
          "storageKey": null
        },
        (v6/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hidden",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "runId"
        }
      ],
      "concreteType": "AgenticWorkerRun",
      "kind": "LinkedField",
      "name": "run",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "foundDetail",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "agentRunStateSettleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "agentRunStateSettleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a3421d31c20dcc0ec03e437abf2297bf",
    "id": null,
    "metadata": {},
    "name": "agentRunStateSettleQuery",
    "operationKind": "query",
    "text": "query agentRunStateSettleQuery(\n  $agentId: String!\n  $runId: ID!\n) {\n  viewer {\n    agenticWorker(agentId: $agentId) {\n      activeRuns {\n        id\n        scopeKind\n        scopeRowType\n        scopeRowId\n        state\n        rows {\n          rowType\n          rowId\n        }\n      }\n      waitingResults {\n        id\n        runId\n        rows {\n          rowType\n          rowId\n        }\n        state\n        hidden\n      }\n      run(id: $runId) {\n        id\n        scopeKind\n        scopeRowType\n        scopeRowId\n        state\n        rows {\n          rowType\n          rowId\n        }\n        foundDetail\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5f37d6a7f0328e682375d9e2ba4153f0";

export default node;
